import GroupAddTwoToneIcon from "@mui/icons-material/GroupAddTwoTone";
import { Box } from "@mui/system";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Switch } from "react-router-dom";
import PlusIcon from "../../../assets/icons/plusWhiteIcon.svg";
import professionIcon from "../../../assets/icons/professionWhiteIcon.svg";
import rahuIcon from "../../../assets/icons/rahuIcon.svg";
// import ReportIcon from "../../../assets/icons/ReportWhite.svg";
// import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
// import ResumeIcon from "../../../assets/icons/ResumeWhite.svg";
import CustomLoader from "../../../global/components/CustomLoader/CustomLoader";
import FloatingMenu, {
  MenuConfig,
} from "../../../global/components/FloatingMenu/FloatingMenu";
import PrivateRoute from "../../../global/components/PrivateRoute/PrivateRoute";
import strings from "../../../global/constants/StringConstants";
import urls from "../../../global/constants/UrlConstants";
import {
  selectAuthenticated,
  selectIsSubscribed,
  selectRole,
} from "../../../redux/authSlice";
import { doesPageHasComponent } from "../../../utils/AuthorizationManager";
import history from "../../../utils/history";
import { useAppSelector } from "../../../utils/hooks";
import Astrocartography from "../../Admin/Astrocartography/Astrocartography";
import DataDownload from "../../Admin/DataDownload/DataDownload";
import ProductManagement from "../../Admin/ProductManagement/ProductManagement";
import TimeAnalysis from "../../Admin/TimeAnalysis/TimeAnalysis";
import ProfessionPhased from "../../Admin/ProfessionPhased/ProfessionPhased";
import Analysis from "../../Analysis/Analysis";
import GenerateReportAdmin from "../../Analysis/Components/Report/GenerateReportAdmin";
import PdfConvertor from "../../Analysis/Components/Report/PdfConvertor";
import Resume from "../../Analysis/Components/Resume/Resume";
import Calculator from "../../Calculator/Calculator";
import Compatibility from "../../Compatibility/Compatibility";
import Dashboard from "../../Dashboard/Dashboard";
import AddData from "../../LandingPage/AddData";
import PageNotFound from "../../PageNotFound/PageNotFound";
import Pricing from "../../Pricing/Pricing";
import ProfessionAnalysis from "../../ProfessionAnalysis/ProfessionAnalysis";
import Profile from "../../Profile/Profile";
import PromoCode from "../../PromoCode/PromoCode";
import RagChatbot from "../../RagChatbot/RagChatbot";
import UpdatePassword from "../../ResetPassword/ResetPassword";
import Settings from "../../Settings/Settings";
import Subscriptions from "../../Subscriptions/Subscriptions";
import Tasks from "../../Tasks/Tasks";
import UserCompatibility from "../../UserCompatibility/UserCompatibility";
import UserManagement from "../../UserManagement/UserManagement";
import UserProfile from "../../UserProfile/UserProfile";
import AboutVedaz from "../../AboutVedaz/AboutVedaz";
import VedazTalk from "../../VedazTalk/VedazTalk";
import VedazChatArea from "../../VedazTalk/components/VedazChatArea";
import VedazCompatibility from "../../VedazTalk/components/VedazCompatibility";
import AppDrawer from "../AppDrawer/AppDrawer";
import AppFooter from "../AppFooter/AppFooter";
import AppHeader from "../AppHeader/AppHeader";
import RahuTransitDialog from "../Dialogs/RahuTransitDialog/RahuTransitDialog";
import layoutStyles from "./Layout.styles";

interface CustomProps {
  location?: Location;
}

const Layout = (props: CustomProps) => {
  const classes = layoutStyles;
  const isAuthenticated = useAppSelector(selectAuthenticated);
  const isSubscribed = useAppSelector(selectIsSubscribed);
  const isAdmin = useAppSelector(selectRole) === strings.ADMIN;
  const role = useAppSelector(selectRole);
  const { t } = useTranslation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [isRahuTransitOpen, setIsRahuTransitOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [topMenuOpen, setTopMenuOpen] = useState(false);
  const [bottomMenuOpen, setBottomMenuOpen] = useState(false);

  const handleTransitClick = () => {
    setIsRahuTransitOpen(true);
  };

  const topMenuConfig: MenuConfig = {
    // round menu classes: ['openFirstBtn', 'openSecondBtn', 'openThirdBtn', 'openFourthBtn', 'openFifthBtn']
    round: [
      {
        icon: rahuIcon,
        label: `${t("rahuTransit")}`,
        openClass: "openFifthBtn",
        handleClick: handleTransitClick,
      },
    ],
    line: [
      // { icon: rahuIcon, label: "Images", handleClick: handleTransitClick },
    ],
  };

  const bottomMenuConfig: MenuConfig = {
    round: [
      {
        icon: professionIcon,
        label: `${t("profession")}`,
        openClass: "openFirstBtn",
        handleClick: () => {
          history.push(urls.professionAnalysisViewPath);
        },
      },
      {
        icon: PlusIcon,
        label: `${t("addData")}`,
        openClass: "openSecondBtn",
        handleClick: () => {
          history.push(urls.addDataViewPath);
        },
      },
      {
        icon: GroupAddTwoToneIcon,
        label: `${t("userManagement")}`,
        openClass: "openThirdBtn",
        handleClick: () => {
          history.push(urls.userManagementViewPath);
        },
      },
      // {
      //   icon: ResumeIcon,
      //   label: `${t("resume")}`,
      //   openClass: "openFourthBtn",
      //   handleClick: () => {
      //     history.push(urls.resumeViewPath);
      //   },
      // },
      // {
      //   icon: ReportIcon,
      //   label: `${t("report")}`,
      //   openClass: "openFourthBtn",
      //   handleClick: () => {
      //     history.push(urls.generateReportViewPath);
      //   },
      // },
      // {
      //   icon: ForumRoundedIcon,
      //   label: `${t("ragChatbot")}`,
      //   openClass: "openFifthBtn",
      //   handleClick: () => {
      //     history.push(urls.ragChatbotViewPath);
      //   },
      // },
    ],
    line: [],
  };

  const handleTopMenuToggle = (value: boolean) => {
    setTopMenuOpen(value);
    if (value) setBottomMenuOpen(false);
  };

  const handleBottomMenuToggle = (value: boolean) => {
    setBottomMenuOpen(value);
    if (value) setTopMenuOpen(false);
  };

  const getContent = () => {
    return (
      <Box sx={classes.content}>
        <Switch>
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.DASHBOARD}
            path={urls.dashboardViewPath}
            component={Dashboard}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.PRICING}
            path={[urls.pricingViewPath, urls.paymentViewPath]}
            component={Pricing}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.USER_PROFILE}
            path={urls.userProfileViewPath}
            component={UserProfile}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.SUBSCRIPTION}
            path={urls.subscriptionViewPath}
            component={Subscriptions}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.UPDATE_PASSWORD}
            path={urls.updatePasswordViewPath}
            component={UpdatePassword}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.PROFESSION_ANALYSIS}
            path={urls.professionAnalysisViewPath}
            component={ProfessionAnalysis}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.ADD_DATA}
            path={urls.addDataViewPath}
            component={AddData}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.RESUME}
            path={urls.resumeViewPath}
            component={Resume}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.REPORT_ADMIN}
            path={urls.generateReportViewPath}
            component={GenerateReportAdmin}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.PROFILE}
            path={urls.profileViewPath}
            component={Profile}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.CALCULATOR}
            path={urls.calculateViewPath}
            component={Calculator}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.ANALYSIS}
            path={[
              urls.analysisViewPath,
              urls.missingMineralsViewPath,
              urls.mahadashaViewPath,
              urls.planetDetailsViewPath,
              urls.footballPredictionViewPath,
              urls.nakshatraAnalysisViewPath,
              urls.circularChartViewPath,
              urls.reportViewPath,
              urls.currentNakshatraViewPath,
              urls.rahuTransitsViewPath,
              urls.housesViewPath,
              urls.arudhaPadaViewPath,
              urls.shadbalaViewPath,
              urls.karmicResourcesViewPath,
              urls.aspectsViewPath,
            ]}
            component={Analysis}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.VEDAZ_TALK}
            path={urls.vedazTalkViewPath}
            component={VedazTalk}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.VEDAZ_CHAT}
            path={urls.vedazChatViewPath}
            component={VedazChatArea}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.COMPATIBILITY}
            path={urls.vedazCompatibilityViewPath}
            component={VedazCompatibility}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.TWO_PERSON_COMPATIBILITY_ADMIN}
            path={urls.compatibilityAdminViewPath}
            component={Compatibility}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.TWO_PERSON_COMPATIBILITY}
            path={urls.compatibilityViewPath}
            component={UserCompatibility}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.GET_PDF}
            path={urls.getReportViewPath}
            component={PdfConvertor}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.USER_MANAGEMENT}
            path={urls.userManagementViewPath}
            component={UserManagement}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.PROMOCODE}
            path={urls.promocodeViewPath}
            component={PromoCode}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.TASKS}
            path={urls.tasksViewPath}
            component={Tasks}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.DATA_DOWNLOAD}
            path={urls.dataDownloadViewPath}
            component={DataDownload}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.PRODUCT_MANAGEMENT}
            path={urls.productManagementViewPath}
            component={ProductManagement}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.TIME_ANALYSIS}
            path={urls.timeAnalysisViewPath}
            component={TimeAnalysis}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.PROFESSION_PHASED}
            path={urls.professionPhasedViewPath}
            component={ProfessionPhased}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.ASTROCARTOGRAPHY}
            path={urls.astrocartographyViewPath}
            component={Astrocartography}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.RAG_CHATBOT}
            path={urls.ragChatbotViewPath}
            component={RagChatbot}
            isSubscribed={isAdmin || isSubscribed}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.ABOUT_VEDAZ}
            path={urls.aboutVedazViewPath}
            component={AboutVedaz}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            componentName={strings.SETTINGS}
            path={urls.settingsViewPath}
            component={Settings}
            isSubscribed={true}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={""}
            component={PageNotFound}
            componentName={strings.PAGENOTFOUND}
          />
        </Switch>
      </Box>
    );
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const getLayout = () => {
    return (
      <>
        <AppHeader />
        <Box sx={classes.root}>
          {doesPageHasComponent("appdrawer") && (
            <AppDrawer setMenuMobileVisible={toggleDrawer} />
          )}
          {getContent()}
          {doesPageHasComponent("profile") && (
            <FloatingMenu
              menuConfigs={topMenuConfig}
              position="top"
              isOpen={topMenuOpen}
              onToggle={handleTopMenuToggle}
              otherMenuOpen={bottomMenuOpen}
            />
          )}
          {/* {role === strings.ADMIN && (
            <FloatingMenu
              menuConfigs={bottomMenuConfig}
              position="bottom"
              isOpen={bottomMenuOpen}
              onToggle={handleBottomMenuToggle}
              otherMenuOpen={topMenuOpen}
              menuIcon={
                <SecurityIcon htmlColor="#ffffff" sx={{ fontSize: "25px" }} />
              }
            />
          )} */}

          <RahuTransitDialog
            handleClose={() => setIsRahuTransitOpen(false)}
            open={isRahuTransitOpen}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
          />
          <CustomLoader isLoading={isLoading} />
        </Box>
        <AppFooter />
      </>
    );
  };

  return getLayout();
};

export default Layout;
